export function formatDate(date) {
  if (typeof date === 'number') {
    date = new Date(date * 1000)
  }
  const day = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
  const second = [date.getHours(), date.getMinutes(), date.getSeconds()]
  return `${day.join('-')} ${second.join(':')}`
}

export function formatDate2(date) {
  if (typeof date === 'number') {
    date = new Date(date * 1000)
  }
  const day = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
  return `${day.join('/')}`
}

export const getDomain = function () {
  const location = window.location
  return `${location.protocol}//${location.hostname}`
}

export const jsonParse = function (str) {
  if (!(str && typeof str === 'string') || str.includes('webpackHotUpdate')) return {}

  try {
    return JSON.parse(str)
  } catch (e) {
    console.error(e, str)
  }

  return {}
}

export const parseSpeed = function (speed) {
  if (speed < 1024) {
    return `${speed.toFixed()}B/s`
  }

  if (speed < 1024 * 1024) {
    return `${(speed / 1024).toFixed()}K/s`
  }

  return `${(speed / (1024 * 1024)).toFixed()}M/s`
}
